export enum AdminConfigTabValue {
  commission = "commission",
  requisites = "requisites",
  currency = "currency",
}
